"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const OsmosysFormSlugField_1 = require("../OsmosysFormSlugField");
exports.OsmosysResourceSlugField = (_a) => {
    var props = tslib_1.__rest(_a, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(OsmosysFormSlugField_1.OsmosysFormSlugField, Object.assign({}, props))));
};
//# sourceMappingURL=OsmosysResourceSlugField.js.map